const resources = (ctx => {
  return ctx.keys().map(ctx).map(res => res.default)
})(require.context('./', true, /^(?!.*index).*\.js$/))

export default resources
